import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { UserRequalifyCertificatePayload } from 'api/actions/user-requalify-certificate/user-requalify-certificate-payload';
import { UserRequalifyCertificatePathParameters } from 'api/actions/user-requalify-certificate/user-requalify-certificate-path-parameters';
import { UserRequalifyCertificateResponse } from 'api/actions/user-requalify-certificate/user-requalify-certificate-response';

type UserRequalifyCertificateQueryParameters = Record<string, any>;

/**
 * The path of the UserRequalifyCertificate action.
 */
export const userRequalifyCertificateActionPath = new SweetPath<keyof UserRequalifyCertificatePathParameters>(
  '/api/user/technician-certificates/{certificateId}/requalify',
  { path: '{param}' }
);

/**
 * Creates a contextualized UserRequalifyCertificate actions.
 */
export default function createUserRequalifyCertificateAction(axios: AxiosInstance) {
  return function userRequalifyCertificateAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: UserRequalifyCertificatePathParameters;
    query?: UserRequalifyCertificateQueryParameters;
    payload: UserRequalifyCertificatePayload;
  }) {
    const path = userRequalifyCertificateActionPath.insert(parameters);

    return axios.request<UserRequalifyCertificateResponse, UserRequalifyCertificateResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
